import base from '../base/base';
import header from '../base/header';
import threeThings from '../../components/threethings/threethings';
import SocialBarLoader from '../../components/SocialBar/SocialBarLoader';
import FsLazyLoad from '../../components/fsLazyLoad/FsLazyLoad';


//fsLazyLoad
let fsLazyLoad = new FsLazyLoad();
fsLazyLoad.init();

new SocialBarLoader();



// WEBPACK FOOTER //
// ./assets/layouts/story/story.js